module.exports = __webpack_public_path__ + "img/longquan4.747731f4.png";